<template>
  <a-modal
    v-model="visible"
    :keyboard="false"
    :maskClosable="false"
    :closable="false"
    :title="success?'报名成功':'您在该项目中有支付订单未支付，请完成支付或者取消方可继续'"
  >
    <a-form v-if="success">
      <a-result
        status="success"
        title="报名成功"
        :is-success="true"
        sub-title="欢迎投标!"
        style="max-width: 560px; margin: 40px auto 0"
      >
      </a-result>
    </a-form>
    <a-card v-else>
      <div class="text-center mb-0">
        <span>订单ID：</span><span>{{ orderId }}</span>
      </div>
      <div class="text-center mb-3">
        <span>实付金额：</span>
        <span class="color-red size4">￥</span>
        <span class="color-red" style="font-size: 40px" v-if="totalMoney">
          {{ totalMoney }}
        </span>
      </div>

      <div>
        <a-tabs
          :defaultActiveKey="defaultActiveKey"
          tabPosition="bottom"
          :tabBarStyle="tabBarStyle"
        >
          <a-tab-pane key="1" :forceRender="forceRender">
            <span slot="tab">
              <img src="../../img/wxpay.png" style="margin: auto" />
            </span>
            <img :src="wxPayUrl" style="margin: auto; height: 220px" />
          </a-tab-pane>
          <a-tab-pane key="2" :forceRender="forceRender">
            <span slot="tab">
              <img src="../../img/alipay.png" />
            </span>
            <iframe
              style="
                width: 220px;
                height: 220px;
                margin: auto;
                border: none;
                display: block;
              "
              :src="aliUrl"
            ></iframe>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>
    <template slot="footer">
      <a-button @click="onSuccess" v-if="success">关闭</a-button>
      <a-button
        v-else
        key="submit"
        type="primary"
        :loading="cancelLoading"
        @click="cancelHandle"
      >
        取消支付
      </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  props: ['projectId'],
  data () {
    return {
      visible: false,
      cancelLoading: false,
      data: [],
      orderId: '',
      wxPayUrl: '',
      totalMoney: '',
      payTimer: null,
      forceRender: true,
      defaultActiveKey: 1,
      aliUrl: '',
      tabBarStyle: {
        'border-bottom': 'none'
      },
      success: false
    }
  },
  mounted () {
    this.initPaymentControl()
  },
  methods: {
    async initPaymentControl () {
      const project = this.projectId
      const response = await this.$http.get(
        '/api/v1/supplier/sign/getAttendOrderByProjectAndSupplier.json?projectId=' +
          project +
          '&type=1'
      )
      if (response.code === 200 && response.result.length > 0) {
        this.visible = true
        this.initAttendOrderData(response.result[0].serialNum)
      }
    },
    async cancelHandle () {
      this.cancelLoading = true
      const response = await this.$http.get(
        '/api/v1/supplier/sign/getAttendOrderByProjectAndSupplier.json?projectId=' +
          this.projectId +
          '&type=2'
      )
      if (response.code === 200) {
        clearInterval(this.payTimer)
        this.cancelLoading = false
        this.visible = false
        this.$emit('finish')
      }
    },
    initAttendOrderData (orderId) {
      if (!orderId) {
        this.$error({
          title: '提示',
          content: '订单ID异常!'
        })
        return
      }
      this.orderId = orderId
      this.aliUrl = '/supplier/alipay.html?orderId=' + orderId
      let that = this
      this.$http
        .get('/api/v1/supplier/sign/get_pack_supplier.json?orderId=' + orderId)
        .then(function (res) {
          that.totalMoney = res.totalMoney
          that.wxPayUrl = res.wxPayUrl
          that.payTimer = setInterval(function () {
            that.$http
              .get('/api/v1/supplier/sign/pay-state.json?orderId=' + orderId)
              .then(function (res) {
                if (res.code === 200) {
                  // 关闭计时器，返回首页
                  clearInterval(that.payTimer)
                  that.success = true
                }
              })
          }, 1000)
        })
    },
    onSuccess () {
      clearInterval(this.payTimer)
      this.$emit('finish')
      this.visible = false
    }
  },
  beforeDestroy () {
    clearInterval(this.payTimer)
  }
}
</script>

<style lang="scss" scoped></style>
